import {
  BRICK_TYPES,
  BRICK_DATA,
  BRICK_WIDTH,
  BRICK_HEIGHT,
  BRICK_START_Y,
  PLAYFIELD,
} from '../core/Constants';

/**
 * Individual Breakout Brick
 */
export class Brick {
  constructor(col, row, type, silverHits = 2) {
    this.col = col;
    this.row = row;
    this.type = type;

    this.width = BRICK_WIDTH;
    this.height = BRICK_HEIGHT;
    this.x = PLAYFIELD.left + col * this.width;
    this.y = BRICK_START_Y + row * this.height;

    const data = BRICK_DATA[type] || { colorIndex: 1, points: 50, hits: 1 };
    this.colorIndex = data.colorIndex;
    this.points = data.points;
    this.isSilver = !!data.silver;
    this.isGold = !!data.unbreakable;

    this.maxHits = this.isSilver ? silverHits : (this.isGold ? -1 : data.hits);
    this.hitsRemaining = this.maxHits;
    this.destroyed = this.type === BRICK_TYPES.EMPTY;

    this.flashTimer = 0.0; // Flash intensity [0..1] when struck
  }

  hit() {
    this.flashTimer = 1.0;
    if (this.isGold) {
      return false; // Can't be destroyed
    }
    if (this.hitsRemaining > 0) {
      this.hitsRemaining--;
      if (this.hitsRemaining === 0) {
        this.destroyed = true;
        return true; // Destroyed!
      }
    }
    return false;
  }

  update(dt) {
    if (this.flashTimer > 0) {
      this.flashTimer = Math.max(0, this.flashTimer - dt * 5.0);
    }
  }

  getBounds() {
    return {
      left: this.x,
      right: this.x + this.width,
      top: this.y,
      bottom: this.y + this.height,
    };
  }
}
